export default __webpack_public_path__ + "static/media/computer-network.a2af3157.svg";